module.exports = __webpack_public_path__ + "img/photography.ecbeabe9.svg";